var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_groups_sprtr form_group with_edit_btn"},[_c('div',{staticClass:"aic_juscb_edit"},[_c('div',{staticClass:"editable_wrpr"},[_c('span',{staticClass:"editable_text"},[_vm._v(_vm._s(_vm.localData.label))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }